import { defineStore } from "pinia";
import { ref } from "vue";
import { API } from "@/queries/index";
import { AxiosError } from "axios";
import { APIResponse, APIResponseError } from "@/types/api";
import { handleResponse, handleResponseError } from "@/utils/api";
import { ModuleDataPayload, ModuleDataResponse } from "@/types/interface/module";

export const useModuleStore = defineStore("moduleStore", () => {
  const module = ref<ModuleDataResponse>();
  const modules = ref<ModuleDataResponse[]>([]);

  function initModules(data: any) {
    modules.value = data?.data;
  }

  function addNewModule(data: any) {
    module.value = data;
  }

  async function dispatchGetAll(page = 1, limit = 10, queryParam = "") : Promise<APIResponse<null>> {
    try {
      const { status, data } = await API.module.getModule(page, limit, queryParam);
      if (status === 200 ) {
        initModules(data);
        return handleResponse(status, data);
      }
    } catch (error) {
      const _error = error as AxiosError<APIResponseError>;
      const errorResponseData = _error.response?.data
      return handleResponseError(errorResponseData)
    }
    return handleResponse(200, null);
  }

  async function dispatchDetail(idMenu = "") : Promise<APIResponse<null>> {
    try {
      const { status, data } = await API.module.findModule(idMenu);
      if (status === 200 ) {
        addNewModule(data);
        return handleResponse(status, data);
      }
    } catch (error) {
      const _error = error as AxiosError<APIResponseError>;
      const errorResponseData = _error.response?.data
      return handleResponseError(errorResponseData)
    }
    return handleResponse(200, null);
  }

  async function dispatchCreate(payload:ModuleDataPayload) : Promise<APIResponse<null>> {
    try {
      const { status, data } = await API.module.createModule(payload);
      if (status === 200 ) {
        addNewModule(data);
        return handleResponse(status, data);
      }
    } catch (error) {
      const _error = error as AxiosError<APIResponseError>;
      const errorResponseData = _error.response?.data
      return handleResponseError(errorResponseData)
    }
    return handleResponse(200, null);
  }

  async function dispatchUpdate(idMenu = "", payload:ModuleDataPayload) : Promise<APIResponse<null>> {
    try {
      const { status, data } = await API.module.updateModule(idMenu, payload);
      if (status === 200 ) {
        addNewModule(data);
        return handleResponse(status, data);
      }
    } catch (error) {
      const _error = error as AxiosError<APIResponseError>;
      const errorResponseData = _error.response?.data
      return handleResponseError(errorResponseData)
    }
    return handleResponse(200, null);
  }

  async function dispatchDelete(idMenu = "") : Promise<APIResponse<null>> {
    try {
      const { status, data } = await API.module.deleteModule(idMenu);
      if (status === 200 ) {
        return handleResponse(status, data);
      }
    } catch (error) {
      const _error = error as AxiosError<APIResponseError>;
      const errorResponseData = _error.response?.data
      return handleResponseError(errorResponseData)
    }
    return handleResponse(200, null);
  }

  return {
    module,
    modules,
    initModules,
    dispatchCreate,
    dispatchUpdate,
    dispatchDetail,
    dispatchGetAll,
    dispatchDelete
  };
});